import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface SwitcherItemProps {
  name: string;
}

function SwitcherItem({name}: SwitcherItemProps): JSX.Element {
  return (
    <a href="#">
      <div className="badge-close pull-right">&times;</div>
      <div className="assembly-title">{name.length === 0 ? <>&nbsp;</> : name}</div>
    </a>
  );
}

export default makeDeprecatedJadeStyleTemplate<SwitcherItemProps>(SwitcherItem);
